import { Flex, Spinner } from '@chakra-ui/react';
import { FormikValues, useFormikContext } from 'formik';
import { Button } from 'ui-components/dist/Button';
import { SOCIAL_PLATFORM_PIPELINE_STATUS } from '~/clientApi/offPlatform.model';
import { ALL_SOCIAL_PLATFORM_TYPE, SOCIAL_PLATFORMS_NAMES } from '~/constants';
import { parseHandle } from '~/screens/ManagePlatforms';
import { PlatformInput, ValuesType } from '~/screens/ManagePlatforms/common';

interface Props {
  platforms: ALL_SOCIAL_PLATFORM_TYPE[];
  searchOPCreators: any;
  onBackClick: () => void;
}

export const PlatformForm: React.FC<Props> = ({
  platforms,
  searchOPCreators,
  onBackClick,
}) => {
  const formik = useFormikContext<FormikValues>();
  const { values } = formik;

  return (
    <Flex direction="column" gap={6}>
      {platforms.map((platform) => (
        <PlatformInput
          key={platform}
          label={SOCIAL_PLATFORMS_NAMES[platform]}
          name={platform}
          isInvalid={
            searchOPCreators.isSuccess &&
            searchOPCreators?.data[platform]?.handle ===
              parseHandle(values[platform as keyof ValuesType]) &&
            searchOPCreators?.data[platform]?.pipelineStatus ===
              SOCIAL_PLATFORM_PIPELINE_STATUS.duplicated
          }
        />
      ))}
      <Flex justifyContent="flex-end" marginTop={4} gap={2}>
        <Button
          variant="tertiary"
          size="md"
          onClick={onBackClick}
          isDisabled={searchOPCreators.isLoading}
        >
          Back
        </Button>
        <Button
          type="submit"
          size="md"
          isDisabled={
            searchOPCreators.isLoading ||
            (!values.instagram &&
              !values.tiktok &&
              !values.snapchat &&
              !values.youtube)
          }
          leftIcon={
            searchOPCreators.isLoading ? <Spinner boxSize={4} /> : undefined
          }
        >
          {searchOPCreators.isLoading ? 'Verifying' : 'Next'}
        </Button>
      </Flex>
    </Flex>
  );
};
